

// $Classes/Enums/Interfaces(filter)[template][separator]
// filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
// template: The template to repeat for each matched item
// separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

// More info: http://frhagn.github.io/Typewriter/

import { DM_DataSheet } from './DM_DataSheet';
import { LSM_LogicSolverSheet_Bar } from './LSM_LogicSolverSheet_Bar';
import { DM_DataSheet_Bar } from './DM_DataSheet_Bar';
import { SS_SupportSystemSheet_Bar } from './SS_SupportSystemSheet_Bar';

export class DeviceBarDevices {
    
    public inputDevices: DM_DataSheet[] = [];
    public actionDevices: DM_DataSheet[] = [];
    public customLogicSolvers: LSM_LogicSolverSheet_Bar[] = [];
    public customDevices: DM_DataSheet_Bar[] = [];
    public customSupportSystems: SS_SupportSystemSheet_Bar[] = [];
}

